import { Component } from 'react';
import PropTypes from 'prop-types';
import withMouseHover from './withMouseHover';

export default function withParentHover(InnerComponent) {
  // HOC won't function if written as a stateless function
  /* eslint-disable react/prefer-stateless-function */
  class WithParentHover extends Component {
    static propTypes = {
      handleMouseEnter: PropTypes.func.isRequired,
      handleMouseLeave: PropTypes.func.isRequired,
    };

    render() {
      const { handleMouseEnter, handleMouseLeave, ...theRest } = this.props;

      return (
        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <InnerComponent {...theRest} />
        </div>
      );
    }
  }

  return withMouseHover(WithParentHover);
}
